import React from 'react';
import Mysubmit from './Mysubmit';


class MyCollections extends React.Component {
    render() {
      return (
           <Mysubmit />
        )
    }
  }
  
  export default MyCollections;